







import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import LoaderBody from '@/shared/components/CheckoutEverywhere/Loader/LoaderBody.vue';

@Component({
  components: {
    LoaderBody,
  }
})
export default class KoinLoadingStep extends Vue {}
